import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Server,
  Database,
  DollarSign,
  Bell,
  Settings,
  ChevronLeft,
  ChevronRight,
  Trash2,
} from 'lucide-react';
import { classNames } from '../lib/utils';

interface SidebarProps {
  collapsed: boolean;
  onToggleCollapse: () => void;
}

const navigation = [
  { path: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { path: '/cleanup', label: 'Cleanup', icon: Trash2 },
  { path: '/accounts', label: 'Accounts', icon: Server },
  { path: '/resources', label: 'Resources', icon: Database },
  { path: '/costs', label: 'Cost Explorer', icon: DollarSign },
  { path: '/alerts', label: 'Alerts', icon: Bell },
  { path: '/settings', label: 'Settings', icon: Settings },
] as const;

export function Sidebar({ collapsed, onToggleCollapse }: SidebarProps) {
  return (
    <aside className={classNames('sidebar', { collapsed })} role="navigation" aria-label="Main navigation">
      <div className="sidebar-header">
        <a href="/" className="sidebar-brand" aria-label="AWS Resource Monitor">
          <div className="sidebar-brand-mark" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 2L2 7l10 5 10-5-10-5z" />
              <path d="M2 17l10 5 10-5" />
              <path d="M2 12l10 5 10-5" />
            </svg>
          </div>
          <span className="sidebar-brand-name">ARM</span>
        </a>
      </div>

      <nav className="sidebar-nav" aria-label="Primary">
        <div className="nav-section">
          <span className="nav-section-title">Monitor</span>
          {navigation.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                classNames('nav-link', { active: isActive })}
              end={item.path === '/dashboard'}
            >
              <item.icon aria-hidden="true" />
              <span className="nav-link-text">{item.label}</span>
            </NavLink>
          ))}
        </div>
      </nav>

      <div className="sidebar-footer">
        <button
          className="btn btn-ghost btn-icon"
          onClick={onToggleCollapse}
          aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {collapsed ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
        </button>
      </div>
    </aside>
  );
}